module.exports = __webpack_public_path__ + "img/logo.5766a64d.png";